export const useLaborComponentsStore = defineStore('laborComponents', {
  state: () => ({
    laborComponents: null as PaginatedLaborComponent | null,
  }),
  getters: {
    getLaborComponents: (state) =>
      state.laborComponents !== null ? state.laborComponents.items : [],
  },
  actions: {
    setLaborComponents(laborComponents: PaginatedLaborComponent) {
      useLocalStorage().setItem('laborComponents', laborComponents);
      this.laborComponents = laborComponents;
    },
    async createLaborComponent(
      laborComponent: LaborComponentCreateUpdate,
    ): Promise<LaborComponent | undefined> {
      try {
        const {data} = await apiPostLaborComponent(laborComponent);
        pushDataToPaginatedState(this.laborComponents, data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readLaborComponents({
      offset,
      limit,
      search,
    }: {offset?: number; limit?: number; search?: string} = {}): Promise<
      PaginatedLaborComponent | undefined
    > {
      const localStorageLaborComponents: PaginatedLaborComponent | null =
        useLocalStorage().getItem('laborComponents');
      if (localStorageLaborComponents) this.setLaborComponents(localStorageLaborComponents);
      try {
        const {data} = await apiGetLaborComponents(limit, offset, search);
        this.setLaborComponents(data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readLaborComponentById(id: string | number): Promise<LaborComponent | undefined> {
      const localStorageLaborComponents: PaginatedLaborComponent | null =
        useLocalStorage().getItem('laborComponents');
      if (localStorageLaborComponents) {
        const foundLaborComponent = localStorageLaborComponents.items.find((c) => c.id === id);
        if (foundLaborComponent !== undefined) return foundLaborComponent;
      }
      try {
        const {data} = await apiGetLaborComponent(id);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async updateLaborComponent(
      laborComponent: LaborComponentCreateUpdate,
    ): Promise<LaborComponent | undefined> {
      try {
        const {data} = await apiPutLaborComponent(laborComponent);
        // Push the object to state.
        if (this.laborComponents !== null) {
          const index = this.laborComponents.items.findIndex((c) => c.id === data.id);
          this.laborComponents.items[index] = data;
          useLocalStorage().setItem('laborComponents', this.laborComponents);
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteLaborComponent(id: number): Promise<void> {
      try {
        await apiDeleteLaborComponent(id);
        // Remove the object from state.
        if (this.laborComponents !== null) {
          const index = this.laborComponents.items.findIndex((c) => c.id === id);
          this.laborComponents.items.splice(index, 1);
          useLocalStorage().setItem('laborComponents', this.laborComponents);
          this.laborComponents.total -= 1;
        }
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
  },
});
